import firebase from 'firebase';
export const enableViewReportsForAllUsers = firebase.functions().httpsCallable('enableViewReportsForAllUsers');
export const getDistrictEnrollmentSettings = firebase.functions().httpsCallable('getDistrictEnrollmentSettings');
export default 'AdvancedSettings.api.js';
